const initializeFormModal = () => {
  function onClick(event) {
    if (event.target === dialog) {
      dialog.close();
    }
  }

  const dialog = document.querySelector(".pinned-contact-form-dialog");

  if (dialog) {
    dialog.addEventListener("click", onClick);
  }
};

if (document.readyState !== "loading") {
  initializeFormModal();
} else {
  document.addEventListener("DOMContentLoaded", initializeFormModal);
}
